import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from "@/components/ui/select";
import { cn } from "@/lib/utils";

import type { OptionValue, SelectOption } from "../TraderDetailsStepOne/types";

interface TraderDetailsProfileSelectProps {
  id: string;
  value?: SelectOption | null;
  options: SelectOption[];
  placeholder: string;
  errorMessage?: string;
  isDisabled?: boolean;
  onBlur: () => void;
  onChange: (option: SelectOption | null) => void;
}

const toSelectValue = (value?: OptionValue | null) =>
  value === undefined || value === null ? undefined : String(value);

const findOptionByValue = (options: SelectOption[], value: string) =>
  options.find(option => toSelectValue(option.value) === value) ?? null;

export const TraderDetailsProfileSelect = ({
  id,
  value,
  options,
  placeholder,
  errorMessage,
  isDisabled = false,
  onBlur,
  onChange,
}: TraderDetailsProfileSelectProps) => (
  <Select
    value={toSelectValue(value?.value)}
    onValueChange={nextValue => onChange(findOptionByValue(options, nextValue))}
    disabled={isDisabled}
  >
    <SelectTrigger
      id={id}
      aria-invalid={!!errorMessage}
      aria-describedby={errorMessage ? `${id}-error` : undefined}
      onBlur={onBlur}
      className={cn(
        "h-10 w-full border-border",
        errorMessage && "border-destructive ring-destructive/20"
      )}
    >
      <SelectValue placeholder={placeholder} />
    </SelectTrigger>
    <SelectContent position="popper" className="max-h-72">
      {options.map(option => {
        const optionValue = toSelectValue(option.value);
        if (!optionValue) {
          return null;
        }

        return (
          <SelectItem key={optionValue} value={optionValue}>
            {option.label}
          </SelectItem>
        );
      })}
    </SelectContent>
  </Select>
);
